/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-prototype-builtins */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Peer from 'simple-peer';
import styled from 'styled-components';

import { Ar } from '../../../components/Ar';
import { Path } from '../../../router/paths';
import BottomBar from '../BottomBar/BottomBar';
import Chat from '../Chat/Chat';
import socket from '../socket';
import VideoCard from '../Video/VideoCard';

const RoomContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100dvh - 130px);

  @media (min-width: 700px) {
    height: calc(100dvh - 150px);
  }
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
`;

const VideoContainer = styled.div`
  max-width: 100%;
  height: 100%;
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  gap: 10px;
`;

const TwoPartyContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
`;

const WaitingMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  text-align: center;
  pointer-events: none;
`;

const PeerNameLabel = styled.div`
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  z-index: 5;
  pointer-events: none;
  white-space: nowrap;
`;

const SoloContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SoloMyVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const PeerFullVideo = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 900px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;

  > video {
    width: 100%;
    max-height: 100%;
    height: auto;
  }
`;

const FloatingVideoWrapper = styled.div`
  position: absolute;
  bottom: 50px;
  right: 20px;
  width: 90px;
  max-width: 600px;
  z-index: 5;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;

  &.expanded {
    width: 65vw;
  }

  @media (min-width: 769px) {
    width: 150px;
    &.expanded {
      width: 300px;
    }
  }

  > video {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 12px;
  }
`;

const VideoAndBarContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  height: 100%;
`;

const MyVideo = styled.video``;

const VideoBox = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 900px;
  max-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  > video {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  :hover {
    > i {
      display: block;
    }
  }
`;

const UserName = styled.div`
  position: absolute;
  font-size: calc(20px + 5vmin);
  z-index: 1;
  color: #fff;
`;

const FaIcon = styled.i`
  display: none;
  position: absolute;
  right: 15px;
  top: 15px;
`;

const Room = (props) => {
  const currentUser = sessionStorage.getItem('user');
  const [peers, setPeers] = useState([]);
  const [userVideoAudio, setUserVideoAudio] = useState({
    localUser: { video: true, audio: true },
  });
  const [videoDevices, setVideoDevices] = useState([]);
  const [displayChat, setDisplayChat] = useState(false);
  const [ArOn, setArOn] = useState(false);
  const [cameraError, setCameraError] = useState(null);
  const [myVideoExpanded, setMyVideoExpanded] = useState(false);
  const [peerLeftMsg, setPeerLeftMsg] = useState(null);
  const isPhysio = sessionStorage.getItem('userRole') === 'physio';

  const [screenShare, setScreenShare] = useState(false);
  const [showVideoDevices, setShowVideoDevices] = useState(false);
  const peersRef = useRef([]);
  const userVideoRef = useRef();
  const screenTrackRef = useRef();
  const userStream = useRef();
  const { roomId } = useParams();
  const navigate = useNavigate();

  const goToBack = (e) => {
    e.preventDefault();
    socket.emit('BE-leave-room', { roomId, leaver: currentUser });
    sessionStorage.removeItem('user');
    navigate(`${Path.THERAPY_PLAN}/${roomId}`);
  };

  useEffect(() => {
    if (userVideoRef.current && userStream.current) {
      userVideoRef.current.srcObject = userStream.current;
    }
  }, [peers.length]);

  useEffect(() => {
    const ueBox = document.querySelector('[class*="mainUe"]');
    if (ueBox) ueBox.style.display = 'none';
    const mainPanel = document.querySelector('[class*="mainPanel"]');
    if (mainPanel) mainPanel.style.paddingBottom = '0';
    return () => {
      if (ueBox) ueBox.style.display = '';
      if (mainPanel) mainPanel.style.paddingBottom = '';
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    const handleReconnect = () => {
      if (!userStream.current || !currentUser) return;
      peersRef.current.forEach(({ peer }) => peer.destroy());
      peersRef.current = [];
      setPeers([]);
      socket.emit('BE-join-room', { roomId, userName: currentUser });
    };
    socket.on('connect', handleReconnect);
    return () => socket.off('connect', handleReconnect);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const filtered = devices.filter((device) => device.kind === 'videoinput');
      setVideoDevices(filtered);
    });

    window.addEventListener('popstate', goToBack);

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: 'user',
        },
        audio: true,
      })
      .then((stream) => {
        userVideoRef.current.srcObject = stream;
        userStream.current = stream;
        socket.emit('BE-join-room', { roomId, userName: currentUser });
        socket.on('FE-user-join', (users) => {
          const peers = [];
          users.forEach(({ userId, info }) => {
            const { userName, video, audio } = info;

            if (userName !== currentUser) {
              const peer = createPeer(userId, socket.id, stream);

              peer.userName = userName;
              peer.peerID = userId;

              peersRef.current.push({
                peerID: userId,
                peer,
                userName,
              });
              peers.push(peer);

              setUserVideoAudio((preList) => {
                return {
                  ...preList,
                  [peer.userName]: { video, audio },
                };
              });
            }
          });

          setPeers(peers);
        });

        socket.on('FE-receive-call', ({ signal, from, info }) => {
          const { userName, video, audio } = info;
          const peerIdx = findPeer(from);

          if (!peerIdx) {
            const peer = addPeer(signal, from, stream);

            peer.userName = userName;
            peer.peerID = from;

            peersRef.current.push({
              peerID: from,
              peer,
              userName,
            });
            setPeers((users) => {
              return [...users, peer];
            });
            setUserVideoAudio((preList) => {
              return {
                ...preList,
                [peer.userName]: { video, audio },
              };
            });
          }
        });

        socket.on('FE-call-accepted', ({ signal, answerId }) => {
          const peerIdx = findPeer(answerId);
          peerIdx.peer.signal(signal);
        });

        socket.on('FE-user-leave', ({ userId }) => {
          const peerIdx = findPeer(userId);
          if (peerIdx) {
            if (!peerIdx.peer.destroyed) peerIdx.peer.destroy();
          } else {
            peersRef.current = peersRef.current.filter(
              ({ peerID }) => peerID !== userId
            );
          }
        });
      })
      .catch((err) => {
        console.error('[Room] Camera/Mic access error:', err);
        if (
          err.name === 'NotAllowedError' ||
          err.name === 'PermissionDeniedError'
        ) {
          setCameraError('denied');
        } else if (
          err.name === 'NotFoundError' ||
          err.name === 'DevicesNotFoundError'
        ) {
          setCameraError('notfound');
        } else {
          setCameraError('unknown');
        }
      });

    socket.on('FE-toggle-camera', ({ userId, switchTarget }) => {
      const peerIdx = findPeer(userId);

      setUserVideoAudio((preList) => {
        let { video } = preList[peerIdx.userName];
        let { audio } = preList[peerIdx.userName];

        if (switchTarget === 'video') video = !video;
        else audio = !audio;

        return {
          ...preList,
          [peerIdx.userName]: { video, audio },
        };
      });
    });

    return () => {
      socket.off('FE-user-join');
      socket.off('FE-receive-call');
      socket.off('FE-call-accepted');
      socket.off('FE-user-leave');
      socket.off('FE-toggle-camera');
      window.removeEventListener('popstate', goToBack);
      if (userStream.current) {
        userStream.current.getTracks().forEach((track) => track.stop());
      }
      peersRef.current.forEach(({ peer }) => {
        if (!peer.destroyed) peer.destroy();
      });
      peersRef.current = [];
    };
    // eslint-disable-next-line
  }, []);

  function handlePeerClose(peer) {
    peersRef.current = peersRef.current.filter((p) => p.peer !== peer);
    setPeers((users) => users.filter((u) => u !== peer));
    setPeerLeftMsg(peer.userName || 'Rozmówca');
    setTimeout(() => setPeerLeftMsg(null), 4000);
  }

  function createPeer(userId, caller, stream) {
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream,
    });

    peer.on('signal', (signal) => {
      socket.emit('BE-call-user', {
        userToCall: userId,
        from: caller,
        signal,
      });
    });
    peer.on('error', () => {
      if (!peer.destroyed) peer.destroy();
    });
    peer.on('close', () => handlePeerClose(peer));
    peer.on('disconnect', () => {
      peer.destroy();
    });

    return peer;
  }

  function addPeer(incomingSignal, callerId, stream) {
    const peer = new Peer({
      initiator: false,
      trickle: false,
      stream,
    });

    peer.on('signal', (signal) => {
      socket.emit('BE-accept-call', { signal, to: callerId });
    });

    peer.on('error', () => {
      if (!peer.destroyed) peer.destroy();
    });
    peer.on('close', () => handlePeerClose(peer));
    peer.on('disconnect', () => {
      peer.destroy();
    });

    peer.signal(incomingSignal);

    return peer;
  }

  function findPeer(id) {
    return peersRef.current.find((p) => p.peerID === id);
  }

  function createUserVideo(peer, index, arr) {
    return (
      <VideoBox
        className={`width-peer${peers.length > 8 ? '' : peers.length}`}
        onClick={expandScreen}
        style={{ color: '#fff' }}
        key={index}
      >
        {writeUserName(peer.userName)}
        <FaIcon className="fas fa-expand" />
        <VideoCard
          key={index}
          peer={peer}
          number={arr.length}
          arOn={isPhysio && ArOn}
        />
      </VideoBox>
    );
  }

  function writeUserName(userName, index) {
    if (userVideoAudio.hasOwnProperty(userName)) {
      if (!userVideoAudio[userName].video) {
        return <UserName key={userName}>{userName}</UserName>;
      }
    }
  }

  const clickChat = (e) => {
    e.stopPropagation();
    setDisplayChat(!displayChat);
  };
  const clickAr = (e) => {
    e.stopPropagation();
    setArOn(!ArOn);
  };

  const toggleCameraAudio = (e) => {
    const target = e.target.getAttribute('data-switch');

    setUserVideoAudio((preList) => {
      let videoSwitch = preList.localUser.video;
      let audioSwitch = preList.localUser.audio;

      if (target === 'video') {
        const userVideoTrack =
          userVideoRef.current.srcObject.getVideoTracks()[0];
        videoSwitch = !videoSwitch;
        userVideoTrack.enabled = videoSwitch;
      } else {
        const userAudioTrack =
          userVideoRef.current.srcObject.getAudioTracks()[0];
        audioSwitch = !audioSwitch;

        if (userAudioTrack) {
          userAudioTrack.enabled = audioSwitch;
        } else {
          userStream.current.getAudioTracks()[0].enabled = audioSwitch;
        }
      }

      return {
        ...preList,
        localUser: { video: videoSwitch, audio: audioSwitch },
      };
    });

    socket.emit('BE-toggle-camera-audio', { roomId, switchTarget: target });
  };

  const clickScreenSharing = () => {
    if (!screenShare) {
      navigator.mediaDevices
        .getDisplayMedia({ cursor: true })
        .then((stream) => {
          const screenTrack = stream.getTracks()[0];

          peersRef.current.forEach(({ peer }) => {
            peer.replaceTrack(
              peer.streams[0]
                .getTracks()
                .find((track) => track.kind === 'video'),
              screenTrack,
              userStream.current
            );
          });

          screenTrack.onended = () => {
            peersRef.current.forEach(({ peer }) => {
              peer.replaceTrack(
                screenTrack,
                peer.streams[0]
                  .getTracks()
                  .find((track) => track.kind === 'video'),
                userStream.current
              );
            });
            userVideoRef.current.srcObject = userStream.current;
            setScreenShare(false);
          };

          userVideoRef.current.srcObject = stream;
          screenTrackRef.current = screenTrack;
          setScreenShare(true);
        });
    } else {
      screenTrackRef.current.onended();
    }
  };

  const expandScreen = (e) => {
    const elem = e.target;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const clickBackground = () => {
    if (!showVideoDevices) return;

    setShowVideoDevices(false);
  };

  const clickCameraDevice = (event) => {
    if (
      event &&
      event.target &&
      event.target.dataset &&
      event.target.dataset.value
    ) {
      const deviceId = event.target.dataset.value;
      const enabledAudio =
        userVideoRef.current.srcObject.getAudioTracks()[0].enabled;

      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId,
            width: { ideal: 1280 },
            height: { ideal: 720 },
          },
          audio: enabledAudio,
        })
        .then((stream) => {
          const newStreamTrack = stream
            .getTracks()
            .find((track) => track.kind === 'video');
          const oldStreamTrack = userStream.current
            .getTracks()
            .find((track) => track.kind === 'video');

          userStream.current.removeTrack(oldStreamTrack);
          userStream.current.addTrack(newStreamTrack);

          peersRef.current.forEach(({ peer }) => {
            peer.replaceTrack(
              oldStreamTrack,
              newStreamTrack,
              userStream.current
            );
          });
        });
    }
  };

  return (
    <RoomContainer onClick={clickBackground}>
      <VideoAndBarContainer>
        {cameraError && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              color: '#fff',
              textAlign: 'center',
              padding: '40px',
              background:
                'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
            }}
          >
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>
              {cameraError === 'denied'
                ? '🔒'
                : cameraError === 'notfound'
                ? '📷'
                : '⚠️'}
            </div>
            <h2 style={{ margin: '0 0 15px 0', fontSize: '24px' }}>
              {cameraError === 'denied' && 'Brak dostępu do kamery'}
              {cameraError === 'notfound' && 'Nie znaleziono kamery'}
              {cameraError === 'unknown' && 'Problem z kamerą'}
            </h2>
            <p
              style={{
                margin: '0 0 25px 0',
                fontSize: '15px',
                opacity: 0.8,
                maxWidth: '400px',
                lineHeight: '1.6',
              }}
            >
              {cameraError === 'denied' &&
                'Aby korzystać z rozmowy wideo, musisz zezwolić na dostęp do kamery i mikrofonu w ustawieniach przeglądarki.'}
              {cameraError === 'notfound' &&
                'Nie wykryto podłączonej kamery. Sprawdź, czy kamera jest podłączona i spróbuj ponownie.'}
              {cameraError === 'unknown' &&
                'Wystąpił nieoczekiwany problem z dostępem do kamery. Sprawdź ustawienia i spróbuj ponownie.'}
            </p>
            <div style={{ display: 'flex', gap: '15px' }}>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '12px 30px',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  backgroundColor: '#42d4f4',
                  color: '#000',
                }}
              >
                Spróbuj ponownie
              </button>
              <button
                onClick={goToBack}
                style={{
                  padding: '12px 30px',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  border: '2px solid #42d4f4',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  color: '#42d4f4',
                }}
              >
                Wróć
              </button>
            </div>
          </div>
        )}
        {!cameraError && (
          <>
            {peers.length === 0 ? (
              <SoloContainer>
                <SoloMyVideo ref={userVideoRef} muted autoPlay playsInline />
                <WaitingMessage>
                  {peerLeftMsg
                    ? `${peerLeftMsg} rozłączył się`
                    : 'Oczekiwanie na dołączenie rozmówcy...'}
                </WaitingMessage>
              </SoloContainer>
            ) : peers.length === 1 ? (
              <TwoPartyContainer>
                <PeerFullVideo>
                  {writeUserName(peers[0].userName)}
                  <VideoCard
                    peer={peers[0]}
                    number={1}
                    arOn={isPhysio && ArOn}
                  />
                  <PeerNameLabel>{peers[0].userName}</PeerNameLabel>
                </PeerFullVideo>
                <FloatingVideoWrapper
                  className={myVideoExpanded ? 'expanded' : ''}
                  onClick={() => setMyVideoExpanded((v) => !v)}
                >
                  <video ref={userVideoRef} muted autoPlay playsInline />
                </FloatingVideoWrapper>
              </TwoPartyContainer>
            ) : (
              <VideoContainer>
                <VideoBox
                  className={`width-peer${
                    peers.length > 8 ? '' : peers.length
                  }`}
                >
                  {userVideoAudio.localUser.video ? null : (
                    <UserName>{currentUser}</UserName>
                  )}
                  <FaIcon className="fas fa-expand" />
                  <MyVideo
                    onClick={expandScreen}
                    ref={userVideoRef}
                    muted
                    autoPlay
                    playInline
                  />
                  {ArOn && <Ar refer={userVideoRef} />}
                </VideoBox>
                {peers &&
                  peers.map((peer, index, arr) =>
                    createUserVideo(peer, index, arr)
                  )}
              </VideoContainer>
            )}
            <BottomBar
              clickScreenSharing={clickScreenSharing}
              clickChat={clickChat}
              clickAr={peers.length > 0 ? clickAr : null}
              clickCameraDevice={clickCameraDevice}
              goToBack={goToBack}
              toggleCameraAudio={toggleCameraAudio}
              userVideoAudio={userVideoAudio.localUser}
              screenShare={screenShare}
              videoDevices={videoDevices}
              showVideoDevices={showVideoDevices}
              setShowVideoDevices={setShowVideoDevices}
              isPhysio={isPhysio}
            />
            <Chat display={displayChat} roomId={roomId} onClose={clickChat} />
          </>
        )}
      </VideoAndBarContainer>
    </RoomContainer>
  );
};

export default Room;
